import { createSlice } from "@reduxjs/toolkit";

const INITIAL_STATE = {
  report: { acronymResults: { acronyms: [] } },
  previousReports: [],
  isReviewMode: false,
  selectedRowIds: [],
};

const acronymReportSlice = createSlice({
  name: "acronyms",
  initialState: INITIAL_STATE,
  reducers: {
    setReport: (state, action) => {
      state.report = action.payload;
    },
    setPreviousReports: (state, action) => {
      state.previousReports = action.payload;
    },
    setIsReviewMode: (state, action) => {
      state.isReviewMode = action.payload;
    },
    deleteReport: (state, action) => {
      state.previousReports = state.previousReports.filter(
        (report) => report.id !== action.payload
      );
    },
    updateReportName: (state, { payload: { reportId, name } }) => {
      state.previousReports = state.previousReports.map((report) =>
        report.id === reportId ? { ...report, name } : report
      );
      if (state.report && state.report.id === reportId) {
        state.report = { ...state.report, name };
      }
    },
    updateMultipleAcronyms: (state, action) => {
      const { ids = [], changes = {} } = action.payload || {};

      if (!Array.isArray(ids) || ids.length === 0) {
        return;
      }

      state.report.acronymResults.acronyms =
        state.report.acronymResults.acronyms.map((item) =>
          ids.includes(item.id) ? { ...item, ...changes } : item
        );
    },
    resetReport: (state) => {
      state.report = INITIAL_STATE.report;
    },
  },
});

export const {
  setReport,
  setLoading,
  setPreviousReports,
  setIsReviewMode,
  deleteReport,
  updateMultipleAcronyms,
  updateReportName,
  resetReport,
} = acronymReportSlice.actions;

export default acronymReportSlice.reducer;
